import React, { memo } from 'react';
//Context
// import { useHome } from './HomeContext';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { Button, Typography, Divider } from '@material-ui/core';
// import { useGeneral } from '../../Context/GeneralContext';

const GeneralData = memo(({
    selectOrder,
    handleChangeOrder,
    ordersF,
    detailOrder,
    fechaIniReal,
    startCorrida,
    isCorridaActive,
    setOpenIni,
    onTerminar
}) => {
    const nodeRef = React.useRef(null);

    // Función para formatear fecha desde UTC a hora local (DD/MM)
    const formatearFechaLocal = (fechaUTC) => {
        if (!fechaUTC) return { dia: '--', mes: '--', hora: '--:--' };
        
        try {
            // new Date() automáticamente convierte fechas UTC (con Z) a hora local del navegador
            // Si la fecha viene sin Z pero es UTC, asegurarse de agregar Z para que se interprete correctamente
            let fechaString = fechaUTC;
            if (typeof fechaUTC === 'string') {
                // Si no tiene indicador de zona horaria (Z, +XX:XX, -XX:XX), asumir UTC y agregar Z
                const tieneZonaHoraria = fechaUTC.endsWith('Z') || 
                                       /[+-]\d{2}:\d{2}$/.test(fechaUTC);
                if (!tieneZonaHoraria) {
                    fechaString = `${fechaUTC}Z`;
                }
            }
            
            const fecha = new Date(fechaString);
            
            // Verificar que la fecha sea válida
            if (isNaN(fecha.getTime())) {
                return { dia: '--', mes: '--', hora: '--:--' };
            }
            
            // Los métodos getDate(), getMonth(), getHours(), getMinutes() devuelven valores en hora local
            const dia = String(fecha.getDate()).padStart(2, '0');
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const horas24 = fecha.getHours();
            const minutos = String(fecha.getMinutes()).padStart(2, '0');
            const ampm = horas24 >= 12 ? 'PM' : 'AM';
            const horas12 = horas24 % 12 || 12;

            return {
                dia: dia,
                mes: mes,
                hora: `${horas12}:${minutos} ${ampm}`
            };
        } catch (error) {
            return { dia: '--', mes: '--', hora: '--:--' };
        }
    };

    // Función para determinar si la fecha es hoy, ayer o mañana (convirtiendo de UTC a hora local)
    const getFechaRelativa = (fechaIni) => {
        if (!fechaIni) return '';
        
        try {
            // Crear fecha desde UTC y convertir a hora local
            const fecha = new Date(fechaIni);
            
            // Obtener fecha en hora local (año, mes, día)
            const fechaLocal = new Date(
                fecha.getFullYear(),
                fecha.getMonth(),
                fecha.getDate()
            );
            
            // Obtener fecha de hoy en hora local (normalizada a medianoche)
            const hoy = new Date();
            hoy.setHours(0, 0, 0, 0);
            
            // Calcular ayer y mañana en hora local
            const ayer = new Date(hoy);
            ayer.setDate(ayer.getDate() - 1);
            
            const manana = new Date(hoy);
            manana.setDate(manana.getDate() + 1);
            
            // Comparar solo las fechas (año, mes, día) sin considerar la hora
            if (fechaLocal.getTime() === hoy.getTime()) {
                return 'Hoy - ';
            } else if (fechaLocal.getTime() === ayer.getTime()) {
                return 'Ayer - ';
            } else if (fechaLocal.getTime() === manana.getTime()) {
                return 'Mañana - ';
            }
            
            return '';
        } catch (error) {
            return '';
        }
    };

    return (
        <div className="generalData-tittle">
            <div className="generalData-titulo">
                <p className="generalData-tittle-style">Datos Generales de la corrida</p>
            </div>

            <Divider className="generalData-divider" style={{ marginTop: '0.15vh', marginBottom: '0.15vh' }} />

            {!selectOrder && !isCorridaActive && ordersF.length > 0 && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '7.5vh',
                    padding: '0 5%',
                    textAlign: 'center',
                }}>
                    <Typography variant="body1" color="textSecondary">
                        Por favor seleccione la siguiente corrida de producción
                    </Typography>
                </div>
            )}

            <div style={{
                marginTop: (!selectOrder && !isCorridaActive) ? '1.5vh' : '0.4vh',
                marginBottom: '0.3vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 'clamp(36px, 5.5vh, 52px)',
                height: 'clamp(36px, 5.5vh, 52px)',
                width: '100%',
                textAlign: 'center',
                padding: '0.3vh 0',
                flexShrink: 0,
                boxSizing: 'border-box',
            }}>
                {ordersF.length === 0 ? (
                    <Typography
                        variant="h6"
                        color="textSecondary"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            width: '100%',
                            margin: 0,
                        }}
                    >
                        No existen corridas asignadas para esta línea.
                    </Typography>
                ) : (
                    <FormControl ref={nodeRef} className="selectLine" disabled={startCorrida} style={{ width: '90%' }}>
                        <InputLabel id="demo-simple-select-label">Corrida</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectOrder}
                            onChange={(e) => handleChangeOrder(e)}
                        >
                            {ordersF.map((item, index) => (
                                <MenuItem value={item.corrida} id={index} key={index}>
                                    <span>
                                        {getFechaRelativa(item.fechaIni)}<b>Orden: </b> {item.ordenProd}, <b>Producto: </b> {item.nombre}{item.cliente ? <>, <b>Cliente: </b> {item.cliente}</> : null}
                                    </span>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            </div>

            <div
                style={{
                    display: isCorridaActive || selectOrder ? 'flex' : 'none',
                    flexDirection: 'column',
                    marginTop: '0.2vh',
                    marginBottom: '0.2vh',
                    flex: 1,
                    height: '100%',
                    minHeight: 0,
                    justifyContent: 'space-between',
                    gap: '0',
                }}
            >
                <div className='generalData-description-tittles-product'>
                    <h1 className="generalData-description-tittle">Producto:</h1>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                        <h1 className="generalData-description-name">
                            {detailOrder.nombre.toLowerCase()}
                        </h1>
                        <h1 className="generalData-description-sku">{`SKU ${detailOrder.sku}`}</h1>
                    </div>
                </div>
                <div className="generalData-description1-tittles">
                    <div className="generalData-description-tittles-order">
                        <h1 className="generalData-orden-tittle">Orden:</h1>
                        <h1 className="generalData-description-name">
                            {detailOrder.ordenProd}
                        </h1>
                    </div>
                    <div className="generalData-description-tittle-meta">
                        <h1 className="generalData-description-tittle-meta-style">Meta:</h1>
                        <h1 className="generalData-description-name">{detailOrder.meta}</h1>
                    </div>
                </div>
                {detailOrder.cliente && (
                    <div className="generalData-description1-tittles">
                        <div className="generalData-description-tittles-order">
                            <h1 className="generalData-orden-tittle">Cliente:</h1>
                            <h1 className="generalData-description-name">{detailOrder.cliente}</h1>
                        </div>
                    </div>
                )}
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        padding: '0 1%',
                        boxSizing: 'border-box',
                        gap: '25%',
                    }}
                >
                    <div style={{
                        flex: 1,
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '4%',
                    }}>
                        <h1 className="generalData-description-tittle-program">Plan:</h1>
                        <div className="generalData-program-description-body" style={{ flexDirection: 'row', gap: '8%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <h1 className="generalData-program-description-body-ini">Inicio:</h1>
                                <div className="generalData-programacion-fechaini-info">
                                    {(() => {
                                        const f = formatearFechaLocal(detailOrder.fechaIni);
                                        return <><span>{f.dia}/{f.mes}</span><span>{f.hora}</span></>;
                                    })()}
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <h1 className="generalData-program-description-body-fin">Fin:</h1>
                                <div className="generalData-programacion-fechaini-info">
                                    {(() => {
                                        const f = formatearFechaLocal(detailOrder.fechaFin);
                                        return <><span>{f.dia}/{f.mes}</span><span>{f.hora}</span></>;
                                    })()}
                                </div>
                            </div>
                        </div>

                    </div>

                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '4%',
                        }}
                    >
                        <h1 className="generalData-description-tittle-program">Real:</h1>
                        <div className="generalData-program-description-body">
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <h1 className="generalData-program-description-body-ini">Inicio:</h1>
                                <div className="generalData-programacion-fechaini-info">
                                    {(() => {
                                        const f = formatearFechaLocal(fechaIniReal);
                                        return <><span>{f.dia}/{f.mes}</span><span>{f.hora}</span></>;
                                    })()}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div
                    className="generalData-programacion-iniciar"
                    style={{
                        display: !startCorrida ? 'flex' : 'none',
                        marginTop: '0',
                    }}
                >
                    <Button
                        className="generalData-programacion-iniciar-boton"
                        variant="contained"
                        onClick={(e) => setOpenIni(true)}
                    >
                        Iniciar
                    </Button>
                </div>
                <div
                    className="generalData-programacion-iniciar"
                    style={{
                        display: !startCorrida ? 'none' : 'flex',
                        marginTop: '0',
                    }}
                >
                    <Button
                        className="generalData-programacion-iniciar-boton-fin"
                        variant="contained"
                        // disabled={isNaN(parseInt(cookie.get('ParoEspecial')))}
                        // onClick={(e) => setOpenC(true)}
                        onClick={onTerminar}
                    >
                        Terminar Corrida
                    </Button>
                </div>
            </div>
        </div>
    );
});

export default GeneralData;
